import React from 'react';
import cs from 'classnames';
import {
  Card,
  Typography,
  CardContent,
  Link,
} from '@forgeglobal/design-framework';
import { LEGAL_LINKS } from '@tcs/common/assets/constants';
import useStyles from './style';

interface Props {
  isVisible: boolean;
  isMobile?: boolean;
}

const NavFooter = ({ isVisible = true, isMobile }: Props) => {
  const classes = useStyles();
  const { TERMS_OF_USE, PRIVACY_POLICY, PRIVACY_NOTICE } = LEGAL_LINKS;

  if (!isVisible && !isMobile) {
    return null;
  }

  return (
    <Card
      className={cs(classes.navCard, {
        [classes.isInvisible]: !isVisible,
        [classes.isMobile]: isMobile,
      })}>
      <CardContent className={classes.footerContent}>
        <Typography
          variant="body1"
          align="center"
          className={classes.footerTitle}>
          Disclosures
        </Typography>
        <Typography variant="caption" color="textSecondary" align="center">
          View Forge Trust’s updated{' '}
          <Link href={TERMS_OF_USE} target="_new">
            Terms of Use
          </Link>
          ,{' '}
          <Link href={PRIVACY_POLICY} target="_new">
            Privacy Policy
          </Link>
          {', and '}
          <Link href={PRIVACY_NOTICE} target="_new">
            Privacy Notice
          </Link>
          {'.'}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default NavFooter;
